// A short message at the bottom of the screen: a green pill, red for errors (as in the Toolkit's shared/lib/toast). One at a
// time; read out by screen readers without moving the focus. `ms` keeps it longer than usual (default 2.6 s, errors 6 s).
let timer: ReturnType<typeof setTimeout> | undefined;
export function toast(msg: string, isErr = false, ms?: number) {
  document.querySelectorAll('.toast').forEach((t) => t.remove());
  const t = document.createElement('div');
  t.className = 'toast' + (isErr ? ' err' : '');
  t.setAttribute('role', isErr ? 'alert' : 'status');
  t.setAttribute('aria-live', isErr ? 'assertive' : 'polite');
  t.textContent = msg;
  document.body.appendChild(t);
  clearTimeout(timer);
  timer = setTimeout(() => t.remove(), ms ?? (isErr ? 6000 : 2600));
}
